import * as React from 'react';

interface MdcIconButtonProps {
  readonly onClick?: () => void;
  readonly className?: string;
  readonly href?: string;
  readonly style?: React.CSSProperties;
  readonly title?: string;
  readonly ariaLabel?: string;
}

const mdcIconButtonStyle: React.CSSProperties = {
  minWidth: '48px',
  minHeight: '48px',
  boxSizing: 'border-box',
  padding: '7px',
  border: '1px solid rgba(255, 255, 255, 0.125)',
  borderRadius: '4px',
  margin: '4px',
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: 'inherit',
  textDecoration: 'none',
};

const MdcIconButton: React.SFC<MdcIconButtonProps> = (props) => {
  return (
    <a
      style={{ ...mdcIconButtonStyle, ...props.style }}
      href={props.href}
      onClick={props.onClick}
      title={props.title}
      aria-label={props.ariaLabel}
      className={`material-icons ${props.className}`}>
      {props.children}
    </a>
  );
};

export default MdcIconButton;
